import React from 'react';

const STEPS = [
    { img: require('../../../../images/landing-pages/companies/sync-datarooms.png'), no: '01', t: 'Give us your documents', d: 'Upload your documents directly or via your cloud' },
    { img: require('../../../../images/landing-pages/companies/ai-autofill.png'), no: '02', t: 'AI auto-fills upto 60%', d: 'Clarence (Our Agent Manager) interrogates your knowledge base and pre-populates answers where she can. Nothing published without your review.' },
    { img: require('../../../../images/landing-pages/companies/certificates.png'), no: '03', t: 'Certify and share', d: 'Bronze, Silver, or Gold self-certification. Share your pack with controlled access — each counter party sees exactly what you choose and when.' },
];

const CompaniesHowItWorks = () => (
    <section id="how-it-works" className="lp-howto-sec">
        <div className="lp-eyebrow" data-lp-reveal>
            <span className="lp-badge lp-badge--up"><span />How it works</span>
        </div>
        <h2 className="lp-howto-head" data-lp-reveal data-lp-delay="60">Scattered documents to certified pack — in 3 steps.</h2>
        <div className="lp-howto">
            {STEPS.map(({ img, no, t, d }, i) => (
                <div className="lp-howstep" key={i} data-lp-reveal data-lp-delay={i * 120}>
                    <div className="lp-howstep-img"><img src={img} alt={t} /></div>
                    <div className="no">{no}</div>
                    <h3>{t}</h3>
                    <p>{d}</p>
                </div>
            ))}
        </div>
    </section>
);

export default CompaniesHowItWorks;
